// index.js
import { default as userReducer } from './reducers';
export { default as userOperations } from './operations';
export { default as userTypes } from './types';
export default userReducer;